import styled from 'styled-components'

export const Wrapper = styled.div``

export const Header = styled.div`
  padding-bottom: 24px;
  svg {
    width: 16px;
    color: #4c4c4c;
    padding: 8px;
    border-radius: 8px;
    background-color: #f0f0f0;
    margin-right: 16px;
    float: left;
    cursor: pointer;
    &:hover {
      color: #213f68;
      background-color: #9ecffa40;
    }
  }
  span {
    font-size: 20px;
    font-weight: 700;
    color: #213f68;
  }
`

export const Subtitle = styled.div`
  color: #213f68;
  font-weight: bold;
  padding-bottom: 8px;
`

export const Buttons = styled.div`
  padding-top: 16px;
  text-align: right;
  button {
    height: 40px;
    border-radius: 8px;
    padding: 0 12px;
    color: #4c4c4c !important;
    background-color: #f0f0f0 !important;
    border: none;
    font-weight: 700;
    &:hover {
      opacity: 0.7;
    }
    &:disabled {
      opacity: 0.48;
    }
  }
  button + button {
    margin-left: 8px;
    color: white !important;
    background-color: #2684ff !important;
  }
`
